import { Button, DownloadIcon } from '@gurupay/gp-ui-library';
import { useStatement } from '@hooks/useStatement';
import { useState } from 'react';

interface DownloadCellProps {
	statementId: string;
	accountId: string;
}

export default function DownloadCell({ statementId, accountId }: DownloadCellProps) {
	const { refetch, isFetching } = useStatement({ statementId, accountId });
	const [isDownloading, setIsDownloading] = useState(false);

	const handleDownload = async () => {
		const { data, error } = await refetch();
		if (error || !data?.file_url) {
			return;
		}

		setIsDownloading(true);
		try {
			window.open(data.file_url, '_blank', 'noopener,noreferrer');
		} finally {
			setIsDownloading(false);
		}
	};

	return (
		<Button
			aria-label="Download statement"
			className="w-[32px] h-[32px]"
			disabled={isFetching || isDownloading}
			icon={<DownloadIcon />}
			id={statementId}
			onClick={handleDownload}
			size="icon"
			variant="secondary"
		/>
	);
}
